import React, { Component } from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';
import { withTranslation } from 'react-i18next';
import i18n from 'cityads-v3/i18n';

import { toISOStringNoTZ } from 'cityads-v3/utils/dateUtils';
import { deepCompare } from 'cityads-v3/utils/arrayUtils';

import {
  setForm,
  saveForm,
  setError,
} from 'cityads-v3/actions/welcomeform';

import Button from '@material-ui/core/Button';
import { DatePicker } from "@material-ui/pickers"
import TextField from 'cityads-v3/components/TextField/TextField';
import ContactField, { Icons } from 'cityads-v3/components/TextField/ContactField'
import WaitingButton from 'cityads-v3/components/Buttons/WaitingButton';

import DateRangeOutlinedIcon from '@material-ui/icons/DateRangeOutlined';
import PermContactCalendarOutlinedIcon from '@material-ui/icons/PermContactCalendarOutlined';
import PhoneOutlinedIcon from '@material-ui/icons/PhoneOutlined';

import classes from './WelcomeForm.scss';

import {
  WEBMASTER_TYPE_PUBLISHER,
  WEBMASTER_TYPE_MEDIABUYER,
  WEBMASTER_TYPE_NETWORK,
} from 'cityads-v3/reducers/welcomeform';

import {
  MAX_DISPLAYED_SELECTED,
  menuProps
} from './WelcomeForm';


const REQUIRED_FIELDS = (webmaster_type) => [{
  name: 'name',
  filter: webmaster_type === WEBMASTER_TYPE_PUBLISHER || webmaster_type === WEBMASTER_TYPE_MEDIABUYER
}, {
  name: 'company',
  filter: webmaster_type === WEBMASTER_TYPE_NETWORK
}];


function checkSomeContacts({ dispatch, form }) {
  const contactError = !Object.keys(form.contacts).some(id => form.contacts[id]);

  if (contactError) {
    dispatch(setError({
      contactError
    }));
    return false;
  }

  dispatch(setError({
    contactError: false
  }));

  return true;
}

export function checkFields({ dispatch, form }) {
  const { webmaster_type } = form;
  let allChecked = true;

  REQUIRED_FIELDS(webmaster_type)
    .filter(item => item.filter || item.filter === undefined)
    .forEach(item => {
      if (!form[item.name]) {
        dispatch(setError({
          [item.name]: true
        }));
        allChecked = false;
      } else if (form[item.name]) {
        dispatch(setError({
          [item.name]: false
        }));
      }
    })
  ;

  if (!checkSomeContacts({ dispatch, form })) {
    allChecked = false;
  }

  return allChecked;
}


@connect(state => ({
  form: state.welcomeform.formData,
  contacts: state.welcomeform.formData.contacts,
  errors: state.welcomeform.errors,
  errorMessages: state.welcomeform.errorMessages,

  contactTypes: state.contactTypes.contactTypes.map(item => state.contactTypes.contactTypesById[item]),
  contactTypesById: state.contactTypes.contactTypesById,

  isLoadingWebmasterInfoForm: state.welcomeform.isLoadingWebmasterInfoForm,
  isSavingForm: state.welcomeform.isSavingForm,
}))
@withTranslation(['Welcome', 'main'], { i18n, wait: !!window })
export default class Step2 extends Component {

  goNext() {
    const { dispatch, form } = this.props;

    if (checkFields({ dispatch, form })) {
      dispatch(saveForm('contacts'))
        .then(() => {
          dispatch(setForm({
            data: {},
            page: 3
          }));
        })
      ;
    }
  }

  goPrev() {
    this.props.dispatch(setForm({
      data: {},
      page: 1
    }));
  }

  checkField(name, newValue) {
    const { errors, dispatch, form } = this.props;
    const newForm = {
      ...form,
      [name]: newValue
    };
    const newErrors = {
      ...errors,
      [name]: !(newForm[name] && newForm[name].length)
    }

    if (!deepCompare(newErrors, errors)) {
      dispatch(setError(newErrors));
    }

    checkSomeContacts({
      dispatch,
      form: newForm
    });
  }

  handleChangeSelectedContacts = evt => {
    const { dispatch, form } = this.props;
    const newSelectedContacts = evt.target.value;
    const contacts = newSelectedContacts.reduce((acc, name) => ({ ...acc, [name]: form.contacts[name] || '' }), {});

    this.checkField('contacts', contacts);

    dispatch(setForm({
      data: {
        contacts,
      },
      page: 2
    }))
  }

  handleChangeForm(name, newValue) {
    const { dispatch } = this.props;

    this.checkField(name, newValue);

    dispatch(setForm({
      data: {
        [name]: newValue
      },
      page: 2
    }));
  }

  handleChangeContactField(name, newValue) {
    const formData = {
      ...this.props.form.contacts,
      [name]: newValue
    };
    this.handleChangeForm('contacts', formData);
  }

  renderContacts() {
    const { contactError } = this.props.errors;
    const { t, contactTypes, form } = this.props;

    const contacts = form.contacts || {};

    return contactTypes.filter(item => contacts.hasOwnProperty(item.id)).map(item => (
      <div key={item.id} className={classes.form__item}>
        <Icons icon={item.id} className={classes.form__item_icon} color="inherit" />

        <TextField
          label={item.name}
          fullWidth={true}
          onChange={evt => this.handleChangeContactField(item.id, evt.target.value)}
          error={!!contactError}
          helperText={contactError ? t('contactsError') : undefined}
          value={contacts[item.id] || ''}
        />
      </div>
    ))
  }

  render() {
    const { webmaster_type, birthday, contacts } = this.props.form;
    const { name, company } = this.props.errors;
    const { t, contactTypesById, form, inline, inlineClasses = {}, isSavingForm, errorMessages } = this.props;

    const selectedContacts = Object.keys(contacts || {});
    const yesterday = new Date((new Date()).valueOf() - 86400000);

    return (
      <div className={classNames(inlineClasses.root, classes.form, classes.form__step2)}>
        {!inline && (
          <div className={classes.form__title}>
            {t('step2')}
          </div>
        )}

        <div className={classNames(classes.form__items, inlineClasses.formItems)}>

          {(webmaster_type === WEBMASTER_TYPE_PUBLISHER || webmaster_type === WEBMASTER_TYPE_MEDIABUYER) && ([
            <div key="name" className={classes.form__item}>
              <PermContactCalendarOutlinedIcon className={classes.form__item_icon} />

              <TextField
                label={t('fields.name')}
                fullWidth={true}
                value={form.name || ''}
                onChange={evt => this.handleChangeForm('name', evt.target.value)}
                error={!!name}
                helperText={name ? getErrorHelper(errorMessages.name) || t('errorEmptyField') : undefined}
              />
            </div>,
            <div key="birthday" className={classes.form__item}>
              <DateRangeOutlinedIcon className={classes.form__item_icon} />

              <DatePicker
                format="DD.MM.YYYY"
                value={birthday ? new Date(birthday.split('T')[0]) : null}
                onChange={evt => this.handleChangeForm('birthday', toISOStringNoTZ(evt.toDate()))}
                animateYearScrolling={false}
                label={t('fields.birthday')}
                maxDate={yesterday}
                initialFocusedDate={yesterday}
                autoOk={true}
                openTo="year"
                cancelLabel={t('main:buttons.cancel')}
                fullWidth={true}
                TextFieldComponent={TextField}
                error={!!errorMessages.birthday}
                helperText={getErrorHelper(errorMessages.birthday)}
              />
            </div>,
          ])}

          {webmaster_type === WEBMASTER_TYPE_NETWORK && ([
            <div key="company" className={classes.form__item}>
              <PermContactCalendarOutlinedIcon className={classes.form__item_icon} />

              <TextField
                label={t('fields.companyName')}
                fullWidth={true}
                onChange={evt => this.handleChangeForm('company', evt.target.value)}
                error={!!company}
                helperText={company ? getErrorHelper(errorMessages.company) || t('errorEmptyField') : undefined}
                value={form.company || ''}
              />
            </div>,
            <div key="contact" className={classes.form__item}>
              <PermContactCalendarOutlinedIcon className={classes.form__item_icon} />

              <TextField
                label={t('fields.contact')}
                fullWidth={true}
                onChange={evt => this.handleChangeForm('name', evt.target.value)}
                error={!!name}
                helperText={name ? getErrorHelper(errorMessages.name) || t('errorEmptyField') : undefined}
                value={form.name || ''}
              />
            </div>
          ])}

          <div className={classes.form__item}>
            <PhoneOutlinedIcon className={classes.form__item_icon} />

            <ContactField
              SelectProps={{
                multiple: true,
                ...menuProps,
                renderValue:selected => selected.slice(0, MAX_DISPLAYED_SELECTED-1).map(item => (contactTypesById[item] || {}).name).join(', ')
              }}
              error={this.props.errors.contactError && selectedContacts.length === 0}
              helperText={this.props.errors.contactError && selectedContacts.length === 0 ? t('contactsError') : undefined}
              label={t('fields.contacts')}
              value={selectedContacts}
              onChange={this.handleChangeSelectedContacts}
            />
          </div>

          {webmaster_type === WEBMASTER_TYPE_NETWORK && (
            <div key="domain" className={classes.form__item}>
              <PermContactCalendarOutlinedIcon className={classes.form__item_icon} />

              <TextField
                label={t('fields.domain')}
                fullWidth={true}
                onChange={evt => this.handleChangeForm('domain', evt.target.value)}
                error={!!errorMessages.domain}
                helperText={getErrorHelper(errorMessages.domain)}
                value={form.domain || ''}
              />
            </div>
          )}

          { this.renderContacts() }

        </div>

        {!inline && (
          <div className={classes.buttons}>
            <Button variant="contained" onClick={() => this.goPrev()}>{t('main:buttons.back')}</Button>
            <WaitingButton
              variant = "contained"
              color   = "primary"
              onClick = {() => this.goNext()}
              waiting = {isSavingForm}
            >
              {t('continue')}
            </WaitingButton>
          </div>
        )}
      </div>
    );
  }

}

function getErrorHelper(messages) {
  if (!messages) {
    return null;
  }

  return messages.map((m, i) => (<React.Fragment key={i}>{m}<br /></React.Fragment>))
}
